export default __webpack_public_path__ + "d3dd0bd9c0c4bc6e1af4eafb4ef2a157.png";